import React from 'react';

import './index.css';

const FormOverlay = (props) => {
    return (
        <div style={props.style || {}} className="form-overlay-container">
            <div className="form-overlay" onClick={props.onFormHide} />

            {props.children}
        </div>
    );
}

export default FormOverlay;



// WEBPACK FOOTER //
// ./src/components/FormOverlay/index.js